import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function CTASection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleScheduleClick = (e) => {
    e.preventDefault();
    navigate("/");
    // Scroll to schedule section after navigation
    setTimeout(() => {
      const scheduleSection = document.getElementById("schedule");
      if (scheduleSection) {
        scheduleSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  };

  return (
    <section className="pt-12 pb-12 bg-slate-50/50 dark:bg-slate-900 transition-colors" id="cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-8 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("taolu_cta.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed mb-8 text-center">
            {t("taolu_cta.text")}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              onClick={handleScheduleClick}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary dark:bg-primary-light text-white text-lg font-semibold rounded-full border-2 border-primary dark:border-primary-light transition-all duration-300 hover:bg-primary/90 dark:hover:bg-primary-light/90 hover:-translate-y-1 hover:shadow-lg"
            >
              {t("taolu_cta.button_schedule")}
            </Link>
            <button
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white dark:bg-slate-800 text-primary dark:text-primary-light text-lg font-semibold rounded-full border-2 border-primary dark:border-primary-light transition-all duration-300 hover:bg-primary/5 dark:hover:bg-primary-light/10 hover:-translate-y-1 hover:shadow-lg"
            >
              {t("taolu_cta.button_tickets")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;

